import { useChatProfileShallowSelector } from 'components/AskDelaChat/ChatProfileStore'
import { useSuggestionsShallowSelector } from 'components/WorkspaceEditor/SuggestionStore'
import { useMemo } from 'react'

/**
 * A custom hook to determine if actions should be disabled based on the user's role or processing state.
 * @returns {boolean} A boolean indicating whether actions should be disabled.
 */
export function useShouldDisableActions(): boolean {
    const role = useChatProfileShallowSelector((state) => state.chatUser?.role)
    const { isAnyTrackChangeProcessing } = useSuggestionsShallowSelector((state) => ({
        isAnyTrackChangeProcessing: state.isAnyTrackChangeProcessing,
    }))
    
    return useMemo(() => {
        // Disable if user is a Reviewer
        if (role === 'Reviewer') return true
        
        // Disable if ANY track change is processing
        if (isAnyTrackChangeProcessing) return true
        
        return false
    }, [role, isAnyTrackChangeProcessing])
}
